import { GETDETAILEDCLIENTORDERLIST_TYPES } from '../actions/getDetailedClientOrderList'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETDETAILEDCLIENTORDERLIST_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer
